import { render } from "./ExamList.vue?vue&type=template&id=5ad37549&scoped=true"
import script from "./ExamList.vue?vue&type=script&lang=js"
export * from "./ExamList.vue?vue&type=script&lang=js"

import "./ExamList.vue?vue&type=style&index=0&id=5ad37549&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ad37549"]])

export default __exports__